import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { environment } from '../../../environments/environment';

export type TelemetryProperties = Record<string, string | number | boolean>;

@Injectable({ providedIn: 'root' })
export class ApplicationInsightsTelemetryService {
  private client?: ApplicationInsights;

  initialize(): void {
    if (!environment.applicationInsights.enabled || !environment.applicationInsights.connectionString || this.client) {
      return;
    }

    this.client = new ApplicationInsights({
      config: {
        connectionString: environment.applicationInsights.connectionString,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        correlationHeaderExcludedDomains: ['cdn.cookielaw.org', 'geolocation.onetrust.com'],
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true
      }
    });

    this.client.loadAppInsights();
    this.client.trackPageView();
  }

  trackEvent(name: string, properties: TelemetryProperties = {}): void {
    this.client?.trackEvent(
      { name },
      { environment: environment.name, ...properties }
    );
  }

  trackSanitizedException(name: string, errorType: string, properties: TelemetryProperties = {}): void {
    this.client?.trackException({
      exception: new Error(`${name} (${errorType})`),
      properties: { environment: environment.name, eventName: name, errorType, ...properties }
    });
  }
}